<template lang="pug">
  v-container.ma-0.pa-0(fluid)
    v-card.pa-0(flat)
      v-card-title.text-h5 Štatistiky
      v-row.ma-0
        v-col(cols="12" md="6")
          v-text-field(
            dense outlined
            v-model="selectedStatistic"
            label="Druh štatistiky"
            readonly)

    v-divider.mb-5.divider-style(full-bleed)
    MenuGroupsAndSlotsStatistics(
      v-if="selectedStatistic")

</template>

<script lang="ts">
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import MenuGroupsAndSlotsStatistics from '@/components/statistics/MenuGroupsAndSlotsStatistics.vue'

@Component({
  components: {
    MenuGroupsAndSlotsStatistics
  }
})

export default class StatisticsPage extends Vue {

  private statistics: any[] = [
    {id: 1, name: 'Štatistika na skupinu'},
  ]
  private selectedStatistic: any | null = null

  mounted () {
    this.selectedStatistic = this.statistics[0].name
  }
}
</script>

<style lang="stylus" scoped>

.divider-style
  .divider-inset-margin
    margin-left -12px
    margin-right 12px

</style>
